export default "__VITE_ASSET__DuEdIhDG__"